import {getGameId} from 'hiya-common/src/utils/helper'
import {formatBigNum} from 'hiya-common/src/utils'
// 获取游戏的引导到状态 yes 即是已引导
export const getGameGuideStatus = (mid) => {
  const game_id = getGameId()
  return localStorage.getItem(`GreedyMold-${game_id}-${mid}`)
}
export const setGameGuideStatus = (mid) => {
  const game_id = getGameId()
  localStorage.setItem(`GreedyMold-${game_id}-${mid}`, 'yes')
}
// 获取游戏的默认下注额度
export const getGameBetChip = () => {
  const game_id = getGameId()
  return Number(localStorage.getItem(`GreedyMoldBet-${game_id}`) || 0)
}
export const setGameBetChip = (num) => {
  const game_id = getGameId()
  localStorage.setItem(`GreedyMoldBet-${game_id}`, num)
}
// 层级问题
export enum ZIndexEnum {
  guidePage = 900,
  guidePageModal = 11000, // 最外层引导层级
  staticPageModal = 10900, // 静态结果弹窗层级
  dynamicPageModal = 10800, // 静态结果弹窗层级
  rulePageModal = 10700, // 静态结果弹窗层级
}

export const mapChangeFinger = [1, 2, 3, 4, 5, 6, 7, 0]
// 对应高亮的真实index，用于换算目标到当前坐标需要跳转的渲染距离
export const mapBoxIndex = [0, 1, 2, 3, 4, 5, 6, 7]
// 划算并补足目前位置到目标位置的index距离，如果距离开奖结果的位置<3
// 就加一部分，例如目前位置到目标位置为0就去让结果渲染动画补一圈
export const getAfterDrawMapBox = ({
  nextIndex,
  targetIndex,
}: {
  nextIndex: number
  targetIndex: number
}) => {
  const distance = targetIndex - nextIndex
  if (distance === 0) {
    // 直接转一圈
    return (
      mapBoxIndex
        // 截取末尾
        .slice(nextIndex)
        // 拼接头部
        .concat(mapBoxIndex.slice(0, targetIndex + 1))
    )
  }
  if (distance > 0) {
    if (distance >= 3) {
      return mapBoxIndex.slice(nextIndex, targetIndex + 1)
    }
    return mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
  }
  if (distance < 0) {
    const normalArr = mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
    if (normalArr.length < 3) {
      return mapBoxIndex
        .slice(nextIndex)
        .concat(mapBoxIndex, mapBoxIndex.slice(0, targetIndex + 1))
    }
  }
  // distance < 0 的情况 也就是target在当前指示的后面 并且距离大于3
  return mapBoxIndex
    .slice(nextIndex)
    .concat(mapBoxIndex.slice(0, targetIndex + 1))
}
// 热门list
export const hot_list = [1, 2, 3]

export const getBigNum = ({
  num,
  max,
  reserveNum,
}: {
  num: number
  max?: number
  reserveNum?: number
}) => {
  if (max && num < max) {
    return num
  }
  return formatBigNum(Number(num) || 0, reserveNum || 1)
}
